import React from 'react';
import { Check, X } from 'lucide-react';
export function QualificationSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-180">
      <div className="max-w-4xl mx-auto" data-id="element-181">
        <div className="grid md:grid-cols-2 gap-6" data-id="element-182">
          <div className="bg-green-50 p-6 rounded-2xl border border-green-100" data-id="element-183">
            <h3 className="text-xl font-bold text-green-800 mb-4 flex items-center" data-id="element-184">
              <Check className="h-5 w-5 mr-2" data-id="element-185" />
              Esto es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-186">
              {['Llegas a mitad de mes contando monedas', "La plata se te va en 'cositas' y no sabes en qué", 'Pagas digital (Yape/Plin) y no sientes el golpe', 'Estás cansada de empezar de nuevo cada mes'].map((item, idx) => <li key={idx} className="flex items-start text-green-900 text-sm" data-id="element-187">
                  <Check className="h-4 w-4 text-green-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-188" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-slate-50 p-6 rounded-2xl border border-slate-200" data-id="element-189">
            <h3 className="text-xl font-bold text-slate-700 mb-4 flex items-center" data-id="element-190">
              <X className="h-5 w-5 mr-2" data-id="element-191" />
              No es para ti si:
            </h3>
            <ul className="space-y-3" data-id="element-192">
              {["Buscas 'hacer dinero rápido' o mágico", 'Quieres inversión avanzada o trading', 'No estás dispuesta a poner límites (aunque sean pequeños)', 'Buscas una fórmula para ser millonaria mañana'].map((item, idx) => <li key={idx} className="flex items-start text-slate-600 text-sm" data-id="element-193">
                  <X className="h-4 w-4 text-slate-400 mr-2 mt-0.5 flex-shrink-0" data-id="element-194" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}